// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"19ba0124","745":"15be0716"}[chunkId] + ".chunk.js";
};